import { useQuery } from 'react-query';

import { QueryEntity } from '../../types';
import useGetFetchConfig from '../../useGetFetchConfig';
import { APIBaseChronos } from '@/api/hosts';
import { ActiveRun } from '@/api/types/backend-dto-types';

export const useFetchAllActiveRuns = () => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<ActiveRun[]>(
    [QueryEntity.AllActiveRuns],
    async () => {
      try {
        const res = await fetch(`${APIBaseChronos}/api/org/runs/all`, fetchConfigGET);
        return await res.json();
      } catch (err) {
        throw err;
      }
    },
    {
      refetchOnWindowFocus: false,
    },
  );
};
